import { useApiClient } from '../useApi/useApiClient';
import { IContactRequest, IContactResponse } from '@/hooks/api/useContact/useContact.interfaces';

export const useContact = () => {
    const { fetch, loading } = useApiClient<IContactResponse>();

    const sendContactForm = async (request: IContactRequest) =>
        await fetch({
            url: '/contact-form',
            method: 'POST',
            body: request,
        });

    return {
        sendContactForm,
        loading,
    };
};
